/**
 * The range a cash amount may take — the till's own limits, declared once.
 *
 * The POS refuses these at entry (`kMaxCashAmountCents`, POS #985). The API
 * holds the same bounds on every cash-drawer route as a fence of its own,
 * because the till is not the only client that can reach those routes:
 *
 *   money movement (pay-in, pay-out, cash drop, deposit, tip hand-in, variance)
 *                                    CASH_MOVEMENT_MIN_CENTS … CASH_AMOUNT_MAX_CENTS
 *   No Sale                          exactly 0 (it moves no money)
 *   starting float, a count line, a count's total
 *                                    0 … CASH_AMOUNT_MAX_CENTS ($0.00 is legal: a
 *                                    till may open with no float, and a till
 *                                    emptied by a drop counts $0.00)
 *
 * All money is integer CENTS.
 */

/**
 * $999,999.99, the largest cash amount a till accepts. It matches the POS's
 * `kMaxCashAmountCents`. 17 nines typed into the old field wrapped NEGATIVE,
 * which is why the cap exists at all.
 */
export const CASH_AMOUNT_MAX_CENTS = 99_999_999;

/** A money movement moves at least one cent. $0.00 is not a movement. */
export const CASH_MOVEMENT_MIN_CENTS = 1;
